import { FilterModel } from './filter.model';
import { FilterType } from './filter.type';
import { YES_NO_FILTER_OPTIONS } from './yes-no-filter-options';

export const SHIPPING_RATE_LIST_FILTERS: FilterModel[] = [
  {
    fieldName: 'is_active',
    label: 'shippingRates.fields.isActive',
    type: FilterType.radio,
    options: YES_NO_FILTER_OPTIONS,
    value: '',
  },
];
